export default __webpack_public_path__ + "static/washer-3018e668d20f130c56f26b5762218b7e.jpg";